import React from "react";
import { Link } from "react-router-dom";
import CcgRoutePremiumPage from "../components/CcgRoutePremiumPage";
import PostcodeQuotenew from "./PostcodeQuotenew";
import "./CcgRoutePremium.css";

const cardGrid = (className, cards) => (
  <div className={className}>
    {cards.map((card) => (
      <article className={card.className || ""} key={card.title}>
        <h3>{card.title}</h3>
        {card.body ? <p>{card.body}</p> : null}
        {card.items ? <ul>{card.items.map((item) => <li key={item}>{item}</li>)}</ul> : null}
        {card.link ? <Link to={card.link.to} className={card.link.className || "route-link-inline"}>{card.link.label}</Link> : null}
        {card.links ? <div className="route-link-btn-row">{card.links.map((link) => <Link to={link.to} className={link.className || "route-link-btn"} key={link.to}>{link.label}</Link>)}</div> : null}
      </article>
    ))}
  </div>
);

const heathrowToAscotRoute = {
  id: "heathrow-to-ascot-taxi",
  path: "/heathrow-to-ascot-taxi",
  liveStripVariant: "windsor",
  seo: {
    title: "Heathrow to Ascot Taxi - Fixed-Price Airport Transfers | CheapCabGrab",
    description:
      "Book a fixed-price taxi from Heathrow Airport to Ascot Racecourse, Royal Ascot, Ascot station and SL5 hotels. Licensed drivers, flight tracking and no surge pricing.",
    keywords:
      "Heathrow to Ascot taxi, Heathrow to Ascot Racecourse taxi, Heathrow to Royal Ascot transfer, Heathrow to Ascot station taxi, Ascot airport transfer, CheapCabGrab",
    canonical: "https://www.cheapcabgrab.com/heathrow-to-ascot-taxi",
    ogTitle: "Heathrow to Ascot Taxi - Fixed Airport Transfers",
    ogDescription:
      "Reliable Heathrow to Ascot taxis with fixed fares, licensed drivers, flight tracking and Royal Ascot pickup planning.",
    serviceName: "CheapCabGrab - Heathrow to Ascot Taxi",
    areaServed: ["Heathrow Airport", "Ascot Racecourse", "Ascot Station", "Royal Ascot", "Sunningdale", "Virginia Water"],
    offerCatalogName: "Heathrow to Ascot Taxi Routes",
    offerName: "Heathrow Airport to Ascot fixed-price taxi",
    offerDescription: "Fixed-price taxi transfers from Heathrow terminals to Ascot Racecourse, Ascot station, hotels and SL5 addresses.",
    reservationName: "Taxi booking from Heathrow to Ascot",
  },
  hero: {
    eyebrow: "Heathrow to Ascot taxi route",
    h1: "Heathrow to Ascot Taxi - Fixed-Price Airport Transfers",
    subtitle: "Heathrow terminals 2, 3, 4 and 5 to Ascot Racecourse, Ascot station, SL5 hotels and Royal Ascot stays.",
    body:
      "Royal Ascot runs Tuesday 16 to Saturday 20 June 2026. Book reliable taxis from Heathrow to Ascot with licensed drivers, flight tracking and secure online booking. Fixed upfront fares with no surge pricing.",
  },
  quote: {
    label: "Get instant quotes",
    note: "Free - Fast - No obligation",
    presetPickup: "Heathrow Airport",
    presetDropoff: "",
    pickupPlaceholder: "Heathrow Airport or terminal",
    dropoffPlaceholder: "Enter Ascot hotel, postcode or racecourse",
  },
  flags: [
    "Royal Ascot 16-20 June 2026 arrival and hotel transfers",
    "Fixed fares agreed upfront - no meters",
    "Heathrow flight tracking and meet-and-greet support",
    "Ascot Racecourse, station and hotel drop-offs",
  ],
  reviewPageKey: "/heathrow-to-ascot-taxi",
  reviewAriaLabel: "Heathrow to Ascot customer reviews",
  statusProfile: "ascot",
  lhrStatusKicker: "Live Ascot + Heathrow intelligence",
  lhrStatusTitle: "Live Ascot checks for Heathrow to Ascot taxis",
  floatingCta: "Book Heathrow to Ascot Taxi",
  mobileCta: "Book Heathrow to Ascot Taxi",
  supportNudge: "Need Heathrow to Ascot help?",
  sections: [
    {
      id: "route-overview",
      title: "Heathrow to Ascot at a glance",
      body: "A premium arrival transfer route for Royal Ascot visitors, racecourse hospitality guests, Ascot hotels, station connections and nearby SL5 stays.",
      render: () => cardGrid("route-overview-grid", [
        {
          title: "Journey basics",
          items: [
            "Distance: Approx. 15-22 miles depending on terminal and drop-off",
            "Typical time: 30-50 minutes",
            "Typical saloon fare: from GBP55-GBP85",
            "Drop-offs: Ascot Racecourse, Ascot station, Sunningdale, Virginia Water and nearby hotels",
          ],
        },
        {
          title: "Great for",
          items: [
            "Heathrow arrivals heading to Royal Ascot",
            "Airport transfers to Ascot hotels and hospitality",
            "Families with luggage, hats or event outfits",
            "MPVs and minibuses for race day groups",
          ],
        },
        {
          title: "Local planning links",
          links: [
            { to: "/ascot-taxi", label: "Ascot taxi" },
            { to: "/ascot-to-heathrow", label: "Ascot to Heathrow", className: "route-link-btn route-link-btn-secondary" },
          ],
        },
      ]),
    },
    {
      id: "route-tools",
      title: "Useful tools for your Heathrow to Ascot journey",
      body: "Check your Heathrow terminal, live status and Ascot visitor planning before you travel.",
      render: () => cardGrid("route-links-grid", [
        { title: "Heathrow Terminal Finder", body: "Check the correct Heathrow terminal before booking your pickup.", link: { to: "/terminalFinder", label: "Open Terminal Finder", className: "route-link-btn" } },
        { title: "Royal Ascot taxi hub", body: "For racecourse, station, hotel and event guidance, use the Ascot taxi hub.", link: { to: "/ascot-taxi", label: "Open Ascot taxi", className: "route-link-btn" } },
        { title: "Group travel", body: "Need more luggage space from Heathrow? Use minibus or coach options for race day groups.", links: [{ to: "/minibus", label: "Minibus" }, { to: "/coach", label: "Coach", className: "route-link-btn route-link-btn-secondary" }] },
      ]),
    },
    {
      id: "route-areas",
      title: "Heathrow to Ascot drop-off areas",
      body: "Book from Heathrow Airport to Ascot Racecourse, Ascot station, local hotels, Sunningdale, Virginia Water and nearby Berkshire addresses.",
      render: () => cardGrid("route-areas-grid", [
        {
          title: "Ascot and racecourse drop-offs",
          items: [
            "Heathrow to Ascot Racecourse",
            "Heathrow to Ascot station",
            "Heathrow to Royal Ascot hotels and hospitality",
            "Heathrow to Sunningdale, Virginia Water and nearby homes",
          ],
          link: { to: "/ascot-taxi", label: "Ascot taxi hub ->" },
        },
        {
          title: "Nearby Heathrow arrival routes",
          items: [
            "Heathrow to Windsor for SL4 hotel stays",
            "Heathrow to Slough for station and hotel drop-offs",
            "Heathrow to Maidenhead for Thames Valley arrivals",
          ],
          links: [
            { to: "/heathrow-to-windsor", label: "Windsor route" },
            { to: "/heathrow-to-slough", label: "Slough route", className: "route-link-btn route-link-btn-secondary" },
            { to: "/heathrow-to-maidenhead", label: "Maidenhead route", className: "route-link-btn route-link-btn-secondary" },
          ],
        },
      ]),
    },
    {
      id: "route-faq",
      title: "Heathrow to Ascot taxi - FAQs",
      body: "Route FAQ for Heathrow arrivals travelling to Ascot Racecourse, Royal Ascot and local hotels.",
      render: () => (
        <div className="route-faq-grid">
          {[
            ["How long does Heathrow to Ascot take?", "Most Heathrow to Ascot taxi journeys take around 30-50 minutes, depending on terminal, M4 or M25 traffic and Ascot event controls."],
            ["Can you pick up from all Heathrow terminals?", "Yes. Use Heathrow Airport as pickup and add your terminal or flight details during booking so pickup timing can be planned around arrivals."],
            ["Can you drop at Ascot Racecourse?", "Yes. Ascot Racecourse and nearby hotel drop-offs are common, but Royal Ascot traffic controls can affect the closest practical drop-off point."],
            ["Do you track flights?", "Yes. Heathrow arrivals are tracked where possible so dispatch timing can account for landing delays and terminal movement."],
          ].map(([title, body]) => <article className="route-faq-card" key={title}><h3>{title}</h3><p>{body}</p></article>)}
        </div>
      ),
    },
    {
      id: "route-support",
      title: "Need help with a Heathrow to Ascot booking?",
      body: "For Royal Ascot timing, extra luggage, MPVs, child seats or multi-stop hotel arrivals, contact support before booking.",
      render: () => (
        <div className="route-support-box">
          <p>Email: <a href="mailto:support@cheapcabgrab.com">support@cheapcabgrab.com</a></p>
          <p>
            Related pages: <Link to="/ascot-taxi">Ascot taxi</Link>,{" "}
            <Link to="/ascot-to-heathrow">Ascot to Heathrow</Link>,{" "}
            <Link to="/heathrow-to-windsor">Heathrow to Windsor</Link> and{" "}
            <Link to="/heathrow-taxi">Heathrow taxi</Link>.
          </p>
        </div>
      ),
    },
  ],
};

const HeathrowToAscotTaxi = () => (
  <CcgRoutePremiumPage route={heathrowToAscotRoute} QuoteComponent={PostcodeQuotenew} />
);

export default HeathrowToAscotTaxi;
